import { Amplify } from 'aws-amplify';
import outputs from '../amplify-outputs.json';

// Use Amplify Gen 2 outputs configuration
const amplifyConfig = outputs;

export function configureAmplifyGen2() {
  try {
    Amplify.configure(amplifyConfig);
    return Amplify.getConfig();
  } catch (error) {
    console.error('Error configuring Amplify:', error);
    // Return a minimal config if configuration fails
    return null;
  }
}

export default configureAmplifyGen2;